export default __webpack_public_path__ + "images/assets/a4533b8e6cc290ef71f97744d6581b00.svg";